<template>

<app-content :loading="is.loading">

	<app-content-head :title="(isNew || !item.game) ? 'Add Game' : item.game.name" back="Convention.Checkout.Wins" :readonly="$authorised('con/checkout/access', 'read')">

		<app-content-head-actions-panel v-if="(item.count) ? item.count.participants : false" text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" v-tooltip="'Export list of eligible participants'" />

		<app-content-head-actions-item v-if="!isWon && !isNew" :loading="is.playering" text="Add" icon="checkout.player" v-on:click="onAddClick" tooltip="Add eligible participant" />

		<app-content-head-actions-item v-if="!isWon && !isNew" :loading="is.awarding" text="Award" icon="play" v-on:click="onGiftClick" tooltip="Randomly award game to eligible participant" />

		<app-content-head-actions-item :divide="!isNew" :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />
		
		<app-content-head-actions-item v-if="!isNew && !isWon" :disabled="isNew || item.winner || is.awarding" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised" v-if="is.initialised">

		<app-content-summary v-if="!isNew">

			<app-content-summary-item label="Status" :tag="$constants.checkout.win.statusName[item.status]" :theme="$constants.checkout.win.statusTheme[item.status]" />
			
			<app-content-summary-item label="Reference" :value="item.reference" />
			
			<app-content-summary-item label="Game" :value="item.game.name" :note="item.game.reference" :link="linkGame" :grow="true" />
			
			<app-content-summary-item label="Won by" :value="item.badge.name" :note="item.badge.reference" :link="linkBadge" :grow="true" v-if="item.badge" />
			
			<app-content-summary-item label="Won by" value="None selected." :grow="true" v-if="!item.badge" :faded="true" />
			
			<app-content-summary-item label="Participants" :value="item.count.participants" alt="0" />
			
			<app-content-summary-item label="Loans" :value="item.count.plays" alt="0" />
			
			<app-content-summary-item label="Awarded On" :value="item.date | localDate('h:mma, dddd')" v-if="item.date" />

		</app-content-summary>

		<app-content-box :readonly="$authorised('con/checkout/access', 'read')" v-if="!isWon">

			<app-input-suggest v-if="isNew" :disabled="item.plays" label="Game" v-model="model.game" :exclude="references.exclude" :validation="$v.model.game" api="convention/game" image="image" placeholder="Search game from library" />

			<app-input-checklist label="Awarding" v-model="model.auto.enabled" :validation="$v.model.auto.enabled" :options="$constants.checkout.win.awarding.enabledName" :descriptions="$constants.checkout.win.awarding.enabledDescription" :fullWidth="true" :singular="true" :columns="1" />

			<app-input-date v-if="model.auto.enabled === 1" :time="true" label="Date" notes="The date the game is automatically awarded to an eligible participant by the system." placeholder="Enter award date..." v-model="model.auto.date" :validation="$v.model.auto.date" />

			<app-input-text v-if="model.auto.enabled === 2" :time="true" label="Threshold" notes="The number of participants required to trigger the game to be automatically awarded to an eligible participant by the system." placeholder="Enter number..." v-model="model.auto.amount" :validation="$v.model.auto.amount" />

		</app-content-box>

		<template v-if="!isNew">
		
			<app-content-section v-if="item.game.reported" icon="game.icon.report" :is-slim="true" title="This game has an open report" description="Click to view details." :route="linkReport" />

			<com-participants :awarded="isWon" :excluded="item.excluded" :win="item.id" v-on:changed="onParticipantChanged" :count="item.count.participants" />

		</template>

	</app-content-body>

	<app-input-items-find title="Find participant to add" placeholder="Search by badge name or reference" v-if="is.adding" api="convention/badge" :is-single="true" :exclude="[]" v-on:save="onAddSaveClick" v-on:close="is.adding = false" />

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'
import comParticipants from './conventioncheckoutwin/Participants'

export default {

	mixins: [mixForm],

	components: {
		'com-participants': comParticipants
	},

	data: function() {

		return {
			references: {
				exclude: []
			},
			is: {
				adding: false,
				awarding: false,
				playering: false
			},
			readonly: this.$authorised('con/checkout/access', 'read'),
			model: {
				id: false,
				game: false,
				auto: {
					enabled: false,
					date: 0,
					amount: 0
				}
			}
		}

	},

	validations: {
		model: {
			game: { required },
			auto: {}
		}
	},

	computed: {

		isWon: function() {
		
			return (this.item.status === this.$constants.checkout.win.status.won) ? this.item.badge.id : false

		},

		linkReport: function() {
		
			return (this.item.game.reported) ? {
				name: 'Convention.Checkout.Reports.Edit',
				params: {
					id: this.item.game.reported
				}
			} : false

		},

		linkBadge: function() {
		
			return (this.item.badge) ? {
				name: 'Convention.Badges.Holders.Edit',
				params: {
					id: this.item.badge.id
				}
			} : false
		
		},

		linkGame: function() {
		
			return (this.item.game && !this.item.game.deleted) ? {
				name: 'Convention.Library.Games.Edit',
				params: {
					id: this.item.game.id
				}
			} : false
		
		},
	
		importexportData: function() {

			return {
				columns: {
					'reference': 'Badge Reference',
					'name': 'Badge Name',
					'email': 'Badge E-mail'
				},
				requiredColumns: [],
				valueMapping: {},
				params: {},
				index: [],
				endpoint: ['convention/checkout/win', this.item.id, 'participants']
			}

		}
	
	},

	methods: {

		onGiftClick: function() {
		
			this.is.awarding = true

			this.$api.post(['convention/checkout/win', this.item.id, 'award']).then(function() {
			
				this.loadItem()
			
			}.bind(this), function() {

				this.$notify({
					type: 'error',
					message: 'Sorry, could not award game.'
				})

				this.is.awarding = false
			
			}.bind(this))

		},

		afterLoad: function() {

			if(this.is.playering) {

				this.$notify({
					message: 'Player added successfully.'
				})
		
				this.is.playering = false
			
			} else if(this.is.awarding) {
			
				this.$notify({
					message: 'Game awarded successfully.'
				})
		
				this.is.awarding = false
			
			}

		},

		onParticipantChanged: function() {
		
			this.loadItem()

		},
	
		onAddClick: function() {
		
			this.is.adding = true
		
		},

		onAddSaveClick: function(value) {

			this.is.playering = false
			this.is.saving = true

			this.$api.post(['convention/checkout/win', this.item.id, 'participants'], {
				id: value[0]
			}).then(function() {

				this.loadItem()

			}.bind(this), function() {

				this.$notify({
					type: 'error',
					message: 'Sorry, participant could not be added.'
				})

				this.is.playering = false
			
			}.bind(this))
		
		}
	
	}

}

</script>

<style scoped>

</style>